// extracted by mini-css-extract-plugin
module.exports = {"rootWrapper":"resetPassword__rootWrapper__Yjd","bounceIn":"resetPassword__bounceIn__3LM","highlightWallMessage":"resetPassword__highlightWallMessage__3if"};